import { render, staticRenderFns } from "./moreDetail.vue?vue&type=template&id=51bf022e&scoped=true"
import script from "./moreDetail.vue?vue&type=script&lang=js"
export * from "./moreDetail.vue?vue&type=script&lang=js"
import style0 from "./moreDetail.vue?vue&type=style&index=0&id=51bf022e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bf022e",
  null
  
)

export default component.exports